<template>
    <div class="h-100 d-flex justify-content-center align-items-center">
        <div class="loader">
          <div class="pacman">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'LoaderPacman'
}
</script>